'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useToolbarButtonBase_unstable: function() {
        return useToolbarButtonBase_unstable;
    },
    useToolbarButton_unstable: function() {
        return useToolbarButton_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactbutton = require("@fluentui/react-button");
const useToolbarButton_unstable = (props, ref)=>{
    const state = useToolbarButtonBase_unstable(props, ref);
    return {
        appearance: 'subtle',
        size: 'medium',
        shape: 'rounded',
        ...state
    };
};
const useToolbarButtonBase_unstable = (props, ref)=>{
    const { vertical = false, ...buttonProps } = props;
    const state = (0, _reactbutton.useButton_unstable)({
        appearance: 'subtle',
        ...buttonProps,
        size: 'medium'
    }, ref);
    return {
        vertical,
        ...state
    };
};
